const urls = {
  base: '/reissue_password/',
};

export function reissuePasswordUrl() {
  return urls.base;
}

export default urls;